import React from 'react'
import { Row, Col, Checkbox } from 'antd'
import IntlMessages from "util/IntlMessages"
import moment from 'moment'
import Widget from 'components/Widget'
import { useSelector } from 'react-redux'
// import DailyHealthReport from './DailyHealthReport'
const PatientReport = () => {

    const reportProps = useSelector(state => state.report)

    const { patientName,fullName, age, sex, email, phoneNumber, dailyUpdate, dailyBaseLine, redFlags } = reportProps && reportProps.reportDetails

    const clientDashboardProps = useSelector(state => state.clientDashboard)
    const { DailyRecord } = clientDashboardProps

    console.log('==============DailyRecord========', DailyRecord)
    let styles = {
        label: {
            fontSize: '13px',
            color: '#989898'
        },
        longBtnLeftGrey: {
            fontSize: '13px',
            background: '#989898',
            border: '1px solid #989898',
            padding: '7px 5px',
            color: "white",
            textTransform: 'capitalize'
        },
        longBtnRightGrey: {
            fontSize: '13px',
            color: '#989898',
            border: '1px solid #989898',
            padding: '7px 40px 7px 10px',
            textTransform: 'capitalize'
        },
        longBtnLeftBlue: {
            fontSize: '13px',
            background: '#0D7DD9',
            border: '1px solid #0D7DD9',
            padding: '7px 5px',
            color: "white",
            textTransform: 'capitalize'
        },
        longBtnRightBlue: {
            fontSize: '13px',
            color: '#0D7DD9',
            border: '1px solid #0D7DD9',
            padding: '7px 40px 7px 10px',
            textTransform: 'capitalize'
        }
    }

    const renderTitle = (title, selectedOptionLabel, baseLineOptionSelect) => {
        return <div >
            <h6 className="gx-blue-font gx-text-capitalize gx-mb-2">{title}</h6>
            <div className="gx-d-flex">
                <div className="gx-d-flex gx-mr-3">
                    <div style={styles.longBtnLeftGrey}>BaseLine:</div>
                    <div style={styles.longBtnRightGrey}> {baseLineOptionSelect}</div>
                </div>

                <div className="gx-d-flex">
                    <div style={styles.longBtnLeftBlue}>Selected:</div>
                    <div style={styles.longBtnRightBlue}>{selectedOptionLabel}</div>
                </div>

            </div>
        </div>
    }
    // const options = [
    //     { label: 'the patient becomes increasingly reluctunt to stand', value: 'Apple' },
    //     { label: 'the patient refuses to sit on low chairs  or on crouches', value: 'Pear' },
    //     { label: 'the patient does not embulates as often', value: 'Orange' },
    // ];

    const dailyUpdateSingleItem = (item, index) => {
        let selectedOption = item.questionOption[item.selected[0]];
        let dailyBaseLineQuestion = dailyBaseLine.filter(Item => Item.questionLabel === item.questionLabel);
        let selectedDailyOption = dailyBaseLineQuestion[0].questionOption[dailyBaseLineQuestion[0].selected[0]];
        return <Widget
            styleName="report-widget"
            title={renderTitle(item.questionLabel, selectedOption.optionLabel, selectedDailyOption.optionLabel)}
        >
            <div dangerouslySetInnerHTML={{ __html: selectedOption.decisionTree }}></div>
        </Widget>
    }

    const renderDailyUpdates = () => {
        if (dailyUpdate && dailyUpdate.length) {
            return dailyUpdate.map((item, index) => {
                return dailyUpdateSingleItem(item, index)
            })
        }
    }

    const renderSingleCheckbox = (selectedOption,questionOption) => {
        if (selectedOption && selectedOption.length) {
            return selectedOption.map((item) => {
                return <Checkbox value={item} checked={true} disabled><span className="gx-text-black">{questionOption[item].optionLabel}</span> </Checkbox>
            })
        }
    }

    const redFlagsSingleItem = (item) => {
        return <Widget
            styleName="report-widget"
            title={<h6 className="gx-blue-font gx-text-capitalize">{item.questionLabel}</h6>}
        >
            <Checkbox.Group defaultValue={item.selected}>
                {renderSingleCheckbox(item.selected, item.questionOption)}
            </Checkbox.Group>
        </Widget>
    }

    const renderRedFlags = () => {
        if (redFlags && redFlags.length) {
            return redFlags.map((item) => {
                return redFlagsSingleItem(item)
            })
        }
    }

    const renderRedFlagCount = (record) => {
        console.log("======== record =======", record);
        let count = 0;
        if (record.redFlags && record.redFlags.length > 0) {
            record.redFlags.forEach(Item => {
                console.log("============= Item.selected.length", Item.selected);
                let selected = (Item.selected && Item.selected.length) || 0;
                count = count + selected
            })
        }

        if (record.dailyBaseLine && record.dailyBaseLine.length > 0) {
            record.dailyBaseLine.forEach((Item, index) => {
                if (Item.selected[0] !== record.dailyUpdate[index].selected[0]) {
                    count = count + 1
                }
            })
        }

        return count === '0' ? <span className="blue-flag">{count}</span> : <span className="red-flag">{count}</span>
    }

    return (
        <div>
            <Row className="gx-mb-4">
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.name" /></span>
                        <span className="gx-blue-font">{patientName || fullName}</span>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.sex" /></span>
                        <span className="gx-blue-font">{sex}</span>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.age" /></span>
                        <span className="gx-blue-font">{age}</span>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.redFlags" /></span>
                        <span className="gx-blue-font">{renderRedFlagCount(reportProps.reportDetails)}</span>
                    </div>
                </Col>
            </Row>
            <Row className="gx-mb-5">
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.email" /></span>
                        <span className="gx-blue-font">{email}</span>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.phone" /></span>
                        <span className="gx-blue-font">{phoneNumber}</span>
                    </div> </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="gx-d-flex gx-flex-column">
                        <span style={styles.label}><IntlMessages id="report.reportModal.baseLineUpdate" /></span>
                        <span className="gx-blue-font">{moment().format('Do MMM YYYY')}</span>
                    </div></Col>

            </Row>

            <h4 className="gx-blue-font gx-mb-5">
                <IntlMessages id="report.reportModal.dailyHealthChanges" />
            </h4>


            {renderDailyUpdates()}



            <h4 className="gx-red-font gx-mb-5">
                <IntlMessages id="report.reportModal.redFlagsHeading" />
            </h4>
            {renderRedFlags()}


            {/* <DailyHealthReport data={DailyRecord} title={<IntlMessages id="dashboard.client.monthlyHealthReport" />} width={'100%'} height={180} axisX={'name'} axisY={['RedFlags']} showYAxis={true} /> */}
        </div>
    )
}

export default PatientReport
